import { render, staticRenderFns } from "./FrsZoneMapLayerLegend.vue?vue&type=template&id=39bd58de&scoped=true&"
import script from "./FrsZoneMapLayerLegend.vue?vue&type=script&lang=js&"
export * from "./FrsZoneMapLayerLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd58de",
  null
  
)

export default component.exports